// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","accent":"#BFD730","primary":"#492172","outer":"_3PJa","title":"_12bs","body":"_3KPe"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/MultiText/MultiTextBoxes/MultiTextBoxes.scss
// module id = ps3t
// module chunks = 0